import { cloneElement, useEffect, useRef } from "react";
import { Route, Link, useLocation, Redirect, Switch } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Projects from "src/components/projects/projects";
import Maps from "src/components/maps/maps";
import WorkLogs from "src/components/workLogs/workLogs";
import Approvals from "src/components/approvals/approvals";
import Purchases from "src/components/purchases/purchases";
import Inventory from "src/components/inventory/inventory";
import PerDiem from "src/components/perdiem/perdiem";
import Vendors from "src/components/vendor/vendor";
import Leads from "src/components/leads/leads";
import Contacts from "src/components/contacts/contacts";
import Opportunities from "src/components/opportunities/opportunities";
import Proposals from "src/components/proposals/proposals";
import Organizations from "src/components/organizations/organizations";
import DashBoard from "src/components/dashboard/dashboard";
import Reports from "src/components/reports/report";
import ProfitMargin from "src/components/profitMargin/profitMargin";
import FleetUsage from "src/components/fleetUsage/fleetUsage";
import TrailerUsage from "src/components/trailerUsage/trailerUsage";
import PaymentMethods from "src/components/paymentMethods/paymentMethods";
import LaborUsage from "src/components/LaborUsage/laborUsage";
import Personnel from "src/components/personel/personel";
import Fleet from "src/components/fleets/fleets";
import Hours from "src/components/hours/hours";
import ProjectCalendar from "src/components/projectCalendar/projectCalendar";
import Billings from "src/components/billings/billings";
import Payroll from "src/components/payroll/payroll";
import LaborCost from "src/components/laborCost/laborCost";
import ImportedBilling from "src/components/importedBilling/importedBilling";
import JobTags from "src/components/JobTags/jobTags";
import OffCalendar from "src/components/offCalendar/offCalendar";
import TimeCard from "src/components/timeCard/timeCard";
import AllTimeCard from "src/components/timeCard/allTimeCard";
import Standby from "src/components/outside/standby/standby";
import Locator from "src/components/outside/locator/locator";
import Calendar from "src/components/calendar/calendar";
import OutsideStatus from "src/components/allOutside/locator/allLocators";
import OutsideStatusStandby from "src/components/allOutside/standby/allStandby";
import PlannedOT from "src/components/outside/pot/pot";
import EmergencyOT from "src/components/outside/eot/eot";
import DailyCallOut from "src/components/outside/daily/daily";
import CheckIn from "src/components/outside/checkIn/checkIn";
import AllPlannedOT from "src/components/allOutside/pot/pot";
import AllEmergencyOT from "src/components/allOutside/eot/eot";
import AllDailyCallOut from "src/components/allOutside/daily/daily";
import AllCheckIn from "src/components/allOutside/checkIn/checkIn";
import Forms from "src/components/forms/forms";
import DayOffs from "src/components/dayOffs/dayOffs";
import Documents from "src/components/documents/documents";
import Newspaper from "src/components/newspaper/newspaper";
import Community from "src/components/community/community";
import WorkOut from "src/components/workOut/workOut";
import Training from "src/components/training/training";
import ProjectForms from "src/components/projectsForms/projectsForms";
import RentalStatus from "src/components/rentalStatus/rentalStatus";
import Database from "src/components/server/database";
import ErrorLog from "src/components/server/error_log";
import FileExpolrer from "src/components/server/fileExplorer";
import Search from "src/components/server/search";
import GasLeakSurvey from "src/components/gasLeakSurvey/gasLeakSurvey";
import OutsideServiceDivision from "src/components/outside/outsideDivision/outsideDivision";
import tasksimg from "src/img/tabs/tasks.png";
import projectsimg from "src/img/tabs/projects.png";
import mapimg from "src/img/tabs/map.png";
import vendorimg from "src/img/tabs/vendor.png";
import purchasesimg from "src/img/tabs/purchases.png";
import perdiemimg from "src/img/tabs/perDiem.png";
import worklogsimg from "src/img/tabs/worklog.png";
import reportsimg from "src/img/tabs/reports.png";
import personelimg from "src/img/tabs/personel.png";
import fleetimg from "src/img/tabs/fleet.png";
import leadsimg from "src/img/tabs/leads.png";
import opportunitiesimg from "src/img/tabs/opportunities.png";
import contactsimg from "src/img/tabs/contacts.png";
import organizationsimg from "src/img/tabs/organizations.png";
import hoursimg from "src/img/tabs/hours.png";
import invoiceimg from "src/img/tabs/invoice.png";
import billingimg from "src/img/tabs/billing.png";
import payrollimg from "src/img/tabs/payroll.png";
import timecardimg from "src/img/tabs/timeCard.png";
import calendarimg from "src/img/tabs/calendar.png";
import offcalendarimg from "src/img/tabs/offcalendar.png";
import statusimg from "src/img/tabs/status.png";
import documentsimg from "src/img/tabs/documents.png";
import communityimg from "src/img/tabs/community.png";
import newspaperimg from "src/img/tabs/newspaper.png";
import formimg from "src/img/tabs/form.png";
import formsimg from "src/img/tabs/forms.png";
import gasleaksurveyimg from "src/img/tabs/forms.png";
import rentalimg from "src/img/tabs/rental.png";
import dayoffimg from "src/img/tabs/vacation.png";
import workoutimg from "src/img/tabs/workout.png";
import trainingimg from "src/img/tabs/training.png";
import safetyimg from "src/img/tabs/safety.png";
import error_logimg from "src/img/tabs/error_log.png";
import databaseimg from "src/img/tabs/database.png";
import searchimg from "src/img/tabs/search.png";
import fileExplorerimg from "src/img/tabs/fileExplorer.png";
import divisionimg from "src/img/tabs/division.png";
import { useMyStore } from "./mainStore";
import {
    outsideStatusExceptions,
    testerEmails,
    laborCostUploaderEmailList,
    BillingUploaderEmailList,
    scroll,
    getDriveFolderId
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function MainMenu(){
    const mainMenuStyle = useMyStore(state => state.mainMenuStyle);
    const user = useMyStore(state => state.user);
    const location = useLocation();
    const tabPath = location.pathname?.split("/")?.[1] ?? "";
    const content = [
        // -- Approval -----------------------------------------------------
        {
            // sql optimized
            // added http cancel
            // mainStore
            show: user.projects === "yes" || user.role.indexOf("Supervisor") > -1,
            title: "Approvals", 
            path: "/Approvals",
            img: tasksimg,
            comp: <Approvals/>,
        },
        // -- CRM ----------------------------------------------------------
        {
            // added http cancel
            // still query all #
            // mainStore #
            show: user.projects !== "no",
            title: "Leads",
            path: "/Leads",
            img: leadsimg,
            comp: <Leads title = {"Leads"}/>,
        },
        {
            // sql optimized
            // added http cancel
            // used hoc loader
            // TransitionWidthHeight hoc
            // pass exact props
            // postUrl removed
            // action removed on Add Item
            // search from server

            // export from server #
            show: user.projects !== "no",
            title: "Contacts",
            path: "/Contacts",
            img: contactsimg,
            comp: <Contacts title = {"Contacts"}/>,
        },
        {
            // added http cancel
            // used hoc loader
            // style => className : header and footer, add <Footer/>

            // export local #
            // contactForm <select name = email1valid/> ???
            show: user.projects !== "no",
            title: "Opportunities",
            path: "/Opportunities",
            img: opportunitiesimg,
            comp: <Opportunities title = {"Opportunities"}/>,
        },
        {
            show: user.projects !== "no" && testerEmails.includes(user.email),
            title: "Proposals",
            path: "/Proposals",
            img: opportunitiesimg,
            comp: <Proposals title = {"Proposals"}/>,
        },
        {
            // sql optimized
            // added http cancel
            // used hoc loader
            // pass exact props
            // postUrl removed
            // action removed on Add Item
            // filter local to server
            // style => className : header and footer, add <Footer/>
             
            // export local #
            show: user.projects !== "no",
            title: "Organizations",
            path: "/Organizations",
            img: organizationsimg,
            comp: <Organizations title = {"Organizations"}/>,
        },
        {
            // style => className : header and footer, add <Footer/>
            show: user.projects !== "no",
            title: "Projects",
            path: "/Projects", 
            img: projectsimg,
            comp: <Projects/>,
        },
        // -- Vehicle ------------------------------------------------------
        {
            // no style object, all className
            show: user.projects !== "no",
            title: "Map",
            path: "/Map",
            img: mapimg,
            comp: <Maps title = {"Map"} coords = {user.coords}/>,
        },
        {
            show: user.projects !== "no",
            title: "Fleets",
            path: "/Fleets",
            img: fleetimg,
            comp: <Fleet title = {"Fleets"}/>,
        },
        // -- Technician ---------------------------------------------------
        {
            show: user.workLogs === "yes",
            title: "Work Logs",
            path: "/WorkLogs",
            img: worklogsimg,
            comp: <WorkLogs title = {"Work Logs"}/>,
        },
        {
            show: user.workLogs === "yes", 
            title: "Hours",
            path: "/Hours",
            img: hoursimg,
            comp: <Hours title = {"Hours"}/>,
        },
        {
            show: user.perDiem !== "no",
            title: "Per Diem",
            path: "/PerDiem",
            img: perdiemimg,
            comp: <PerDiem title = {"Per Diem"}/>,
        },
        // -- Coordinator --------------------------------------------------
        {
            // already internal on server
            // added http cancel

            // search local to server #
            // filter local to server #
            // export local #
            show: user.purchases !== "no",
            title: "Vendors",
            path: "/Vendors",
            img: vendorimg,
            comp: <Vendors title = {"Vendors"}/>,
        },
        {
            // added http cancel
            // sql optimized
            // php normalized
            // already internal on server
            show: user.purchases !== "no",
            title: "Purchases",
            path: "/Purchases",
            img: purchasesimg,
            comp: <Purchases title = {"Purchases"}/>,
        },
        {
            show: user.purchases !== "no",
            title: "Inventory",
            path: "/Inventory",
            img: purchasesimg,
            comp: <Inventory title = {"Inventory"}/>,
        },
        {
            show: user.projects !== "no" || user.calendar === "yes",
            title: "Calendar",
            path: "/Calendar",
            img: calendarimg,
            comp: <Calendar title = {"Calendar"}/>,
        },
        {
            show: user.projects !== "no",
            title: "Off Calendar",
            path: "/OffCalendar",
            img: offcalendarimg,
            comp: <OffCalendar title = {"Off Calendar"}/>,
        },
        {
            show: user.projects !== "no",
            title: "Billings",
            path: "/Billing",
            img: billingimg,
            comp: <Billings/>,
        },
        {
            show: user.projects !== "no",
            title: "Project Calendar",
            path: "/ProjectCalendar",
            img: invoiceimg,
            comp: <ProjectCalendar title = {"Project Calendar"}/>,
        },
        {
            show: user.paymentMethods === "yes",
            title: "Payment Methods",
            path: "/PaymentMethods",
            img: purchasesimg,
            comp: <PaymentMethods title = {"Payment Methods"}/>,
        },
        {
            show: user.projects !== "no",
            title: "Payroll",
            path: "/Payroll",
            img: payrollimg,
            comp: <Payroll title = {"Payroll"}/>,
        },
        {
            show: user.projects === "yes" || laborCostUploaderEmailList.includes(user.email),
            title: "Labor Cost",
            path: "/LaborCost",
            img: invoiceimg,
            comp: <LaborCost title = {"Labor Cost"}/>,
        },
        {
            show: user.projects === "yes" || BillingUploaderEmailList.includes(user.email),
            title: "Imported Billing",
            path: "/ImportedBilling",
            img: invoiceimg,
            comp: <ImportedBilling title = {"Imported Billing"}/>,
        },
        {
            show: user.projects !== "no",
            title: "Job Tags",
            path: "/JobTags",
            img: worklogsimg,
            comp: <JobTags title = {"Job Tags"} path = {"JobTags"}/>,
        },
        {
            show: user.projects !== "no",
            title: "Project Forms",
            path: "/ProjectForms",
            img: formsimg,
            comp: <ProjectForms title = {"Project Forms"}/>,
        },
        {
            show: user.projects !== "no",
            title: "Gas Leak Survey",
            path: "/GasLeakSurvey",
            img: gasleaksurveyimg,
            comp: <GasLeakSurvey title = {"Gas Leak Survey"}/>,
        },
        {
            show: user.projects !== "no",
            title: "Rental Status",
            path: "/RentalStatus",
            img: rentalimg,
            comp: <RentalStatus title = {"Rental Status"}/>,
        },{
            show: user.projects !== "no",
            title: "Reports",
            path: "/Reports",
            img: reportsimg,
            comp: <Reports title = {"Reports"}/>,
        },
        // -- HR -----------------------------------------------------------
        {
            show: ["read", "outside", "dispatch", "yes"].includes(user.personel),
            title: "Personnel",
            path: "/Personnel",
            img: personelimg,
            comp: <Personnel title = {"Personnel"}/>,
        },
        {
            show: user.office === "yes" || user.outside === "runner",
            title: "Time Card",
            path: "/TimeCard",
            img: timecardimg,
            comp: <TimeCard title = {"Time Card"}/>,
        },
        {
            show: user.allOffice !== "no",
            title: "All Time Card",
            path: "/AllTimeCard",
            img: timecardimg,
            comp: <AllTimeCard title = {"All Time Card"}/>,
        },
        // -- Outside Service ----------------------------------------------
        {
            show: 
                user.outsideTimeCards?.split(", ").includes("locator") ||
                user.outsideTimeCards?.split(", ").includes("qew")
            ,
            title: user.outsideTimeCards?.split(", ").length < 2?"Time Card":"Locator",
            path: "/LMTimeCard",
            img: timecardimg,
            comp: <Locator title = {user.outsideTimeCards?.split(", ").length < 2?"Time Card":"Locator"}/>,
        },
        {
            show: user.outsideTimeCards?.split(", ").includes("standby"),
            title: user.outsideTimeCards?.split(", ").length < 2?"Time Card":"Standby",
            path: "/StandbyTimeCard",
            img: timecardimg,
            comp: <Standby title = {user.outsideTimeCards?.split(", ").length < 2?"Time Card":"Standby"}/>,
        },
        {
            show: user.outsideStatus === "yes" && !outsideStatusExceptions.includes(user.email),
            title: "L&M Status",
            path: "/OutsideStatus",
            img: statusimg,
            comp: <OutsideStatus title = {"L&M Status"}/>,
        },
        {
            show: user.outsideStatus === "yes",
            title: "Standby Status",
            path: "/OutsideStatusStandby",
            img: statusimg,
            comp: <OutsideStatusStandby title = {"Standby Status"}/>,
        },
        {
            show: user.outsideStatus === "yes",
            title: "Divisions",
            path: "/OutsideDivisions",
            img: divisionimg,
            comp: <OutsideServiceDivision title = {"OutsideDivisions"}/>,
        },
        {
            show: user.outside !== "no" && user.outside !== "runner",
            title: "Daily Call Out",
            path: "/DailyCallOut",
            img: timecardimg,
            comp: <DailyCallOut title = {"Daily Call Out"}/>,
        },
        {
            show: user.outside !== "no" && user.outside !== "runner",
            title: "Check-In",
            path: "/CheckIn",
            img: timecardimg,
            comp: <CheckIn title = {"Check-In"}/>,
        },
        {
            show: user.outside !== "no" && user.outside !== "runner",
            title: "Emergency OT",
            path: "/EmergencyOT",
            img: timecardimg,
            comp: <EmergencyOT title = {"Emergency OT"}/>,
        },
        {
            show: user.outside !== "no" && user.outside !== "runner",
            title: "Planned OT",
            path: "/PlannedOT",
            img: timecardimg,
            comp: <PlannedOT title = {"Planned OT"}/>,
        },
        {
            show: user.outsideStatus === "yes",
            title: "Check-In",
            path: "/AllCheckIn",
            img: formimg,
            comp: <AllCheckIn title = {"Check-In"}/>,
        },
        {
            show: user.outsideStatus === "yes",
            title: "Daily Call Out",
            path: "/AllDailyCallOut",
            img: formimg,
            comp: <AllDailyCallOut title = {"Daily Call Out"}/>,
        },
        {
            show: user.outsideStatus === "yes",
            title: "Emergency OT",
            path: "/AllEmergencyOT",
            img: formimg,
            comp: <AllEmergencyOT title = {"Emergency OT"}/>,
        },
        {
            show: user.outsideStatus === "yes",
            title: "Planned OT",
            path: "/AllPlannedOT",
            img: formimg,
            comp: <AllPlannedOT title = {"Planned OT"}/>,
        },
        // -- Executive ----------------------------------------------------
        {
            show: user.reports === "yes",
            title: "Dashboard",
            path: "/Dashboard",
            img: reportsimg,
            comp: <DashBoard title = {"Dashboard"}/>,
        },
        {
            show: user.reports === "yes",
            title: "Profit Margin",
            path: "/ProfitMargin",
            img: reportsimg,
            comp: <ProfitMargin title = {"Profit Margin"}/>,
        },
        {
            show: user.reports === "yes",
            title: "Fleet Usage",
            path: "/FleetUsage",
            img: reportsimg,
            comp: <FleetUsage title = {"Fleet Usage"}/>,
        },
        {
            show: user.reports === "yes",
            title: "Trailer Usage",
            path: "/TrailerUsage",
            img: reportsimg,
            comp: <TrailerUsage title = {"Trailer Usage"}/>,
        },
        {
            show: user.reports === "yes",
            title: "Labor Usage",
            path: "/LaborUsage",
            img: reportsimg,
            comp: <LaborUsage title = {"Labor Usage"}/>,
        },
        // -- All Users ----------------------------------------------------
        {
            show: true,
            title: "Forms",
            path: "/Forms",
            img: formsimg,
            comp: <Forms title = {"Forms"}/>,
        },
        {
            // show: true,
            show: user.dayOff != "no",
            title: "Time Offs",
            path: "/DayOffs",
            img: dayoffimg,
            comp: <DayOffs title = {"Time Offs"}/>,
        },
        {
            // show: true,
            show: user.department != "3rd Party",
            title: "Documents",
            path: "/Documents",
            img: documentsimg,
            comp: <Documents title = {"Documents"} rootFolderId = {getDriveFolderId("documentsRoot")}/>,
        },
        {
            // show: true,
            show: user.department != "3rd Party",
            title: "Safety",
            path: "/Safety",
            img: safetyimg,
            comp: <Documents title = {"Safety"} rootFolderId = {getDriveFolderId("safetyRoot")}/>,
        },
        {
            // show: true,
            show: user.newspaper === "yes",
            title: "Newspaper",
            path: "/Newspaper",
            img: newspaperimg,
            comp: <Newspaper title = {"Newspaper"}/>,
        },
        // -- Dev Mode -----------------------------------------------------
        {
            show: testerEmails.includes(user.email),
            title: "Community",
            path: "/Community",
            img: communityimg,
            comp: <Community title = {"Community"}/>,
        },
        {
            show: testerEmails.includes(user.email),
            title: "Training",
            path: "/Training",
            img: trainingimg,
            comp: <Training title = {"Training"}/>,
        },
        {  
            // server notes
            // server error handling (close sql database connection)
            // sql pass exact props (." , ".) ( SELECT * )
            // server redundent &nbsp;</strong></a><br>
            // with internalAuth
            show: testerEmails.includes(user.email),
            title: "WorkOut",
            path: "/WorkOut",
            img: workoutimg,
            comp: <WorkOut title = {"WorkOut"}/>,
        },
        {
            show: testerEmails.includes(user.email),
            title: "Error Log",
            path: "/ErrorLog",
            img: error_logimg,
            comp: <ErrorLog/>,
        },
        {
            show: testerEmails.includes(user.email),
            title: "Search",
            path: "/Search",
            img: searchimg,
            comp: <Search/>,
        },
        {
            show: testerEmails.includes(user.email),
            title: "FileExplorer",
            path: "/FileExplorer",
            img: fileExplorerimg,
            comp: <FileExpolrer/>,
        },
        {
            show: testerEmails.includes(user.email),
            title: "Database",
            path: "/Database",
            img: databaseimg,
            comp: <Database/>,
        }
    ];
    //---------------------------------------------------------------------------------------------------------------------
    return(
        <>
        <div className = "mainMenu" style = {mainMenuStyle}>
            <div style = {{background: user.userTheme}}>Menu</div>
            {content.map((value, index) => 
            value.show?
            <MyLink
                active = {value.path === "/" + tabPath}
                key = {index}
                to = {value.path} 
                style = {{
                    backgroundColor: 
                    value.path === "/" + tabPath?"gray" : "",
                    color: value.path === "/" + tabPath? "white" : ""
                }}
                onClick = {() => {scroll(null);}}
            >
                <img src = {value.img} alt = ""/>
                {value.title}
            </MyLink>
            :null)}
        </div>
        <div className = "mainComp">
            <Switch>
                {content.map((value, index) => 
                value.show?
                <Route key = {index} path = {value.path}>
                    {cloneElement(value.comp, {
                        tabTitle: value.title, 
                        tabPath: value.path
                    })}
                </Route>
                :null)}
                <Redirect to = "/"/>
            </Switch>
    </div>
    </>
    )
}

function MyLink({children, active, ...props}){
    const linkRef = useRef();
    useEffect(() => {
      if(linkRef.current && active) linkRef.current.focus();
    }, [active]);
    return (
        <Link ref = {linkRef} {...props}>{children}</Link>
    );
  };